// extracted by mini-css-extract-plugin
export default {"card":"HiBuXqZx7qiW4aVxLL9H","card-expanded":"fIaVqd8dQ11nYkBscauq","title":"BgamaL_cfMWS35EmIZm0","details-content":"j6mAdQC7Rclwb3YMe6kH"};